import { render, staticRenderFns } from "./ViewIssue.vue?vue&type=template&id=04273cbc&"
import script from "./ViewIssue.vue?vue&type=script&lang=js&"
export * from "./ViewIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports